import { Routes } from '~/modules/routes';
import { routerStore } from '../stores/routerStore';

export function upsertQueryParams(
    ...args: Array<[key: string, value: string] | { insert?: Array<[key: string, value: string]>; remove?: string[] }>
) {
    const { queryString } = routerStore.getState();
    const params = new URLSearchParams(queryString || '');

    if (args.length === 0) {
        console.error(`Called 'upsertQueryParams' with no parameters`);
        return params.toString();
    }

    // If first parameter is an array, preserve previous behavior which is to remove the scroll param and insert all params
    if (Array.isArray(args[0])) {
        // Reset the scroll to param when navigating to a new page
        params.delete('scrollTo');

        for (const [key, value] of args as Array<[key: string, value: string]>) {
            params.set(key, value);
        }
        return params.toString();
    }

    // If first parameter is not an array, it's an object with insert and remove fields which give us more control over this function's behavior
    const insert = args[0]?.insert ?? [];
    const remove = args[0]?.remove ?? [];

    // Reset the scroll to param when navigating to a new page
    for (const paramToRemove of remove) {
        params.delete(paramToRemove);
    }

    for (const [key, value] of insert) {
        params.set(key, value);
    }
    return params.toString();
}

export function getLoginUrl() {
    return `/${Routes.LOGIN}?startURL=${window.location.pathname}${window.location.search}`;
}
